(function() { module.exports = window["eventespresso"]["config"]; }());